import React from 'react';
import { styles } from '../styles';
import { Icons } from './Icons';

/**
 * FilterToolbar Component
 * Status filter tabs + search input
 *
 * Props:
 * - stats: { total, pending, inProgress, completed }
 * - statusFilter: 'ALL' | 'PENDING' | 'IN_PROGRESS' | 'COMPLETED'
 * - setStatusFilter: (filter) => void
 * - searchQuery: string
 * - setSearchQuery: (query) => void
 * - searchRef: React ref for input (for parent hotkey focus)
 */
function FilterToolbar({
  stats,
  statusFilter,
  setStatusFilter,
  searchQuery,
  setSearchQuery,
  searchRef
}) {
  // Filter tab configuration
  const tabs = [
    { key: 'ALL', label: 'Tất cả', count: stats.total },
    { key: 'PENDING', label: 'Chờ', count: stats.pending },
    { key: 'IN_PROGRESS', label: 'Đang làm', count: stats.inProgress },
    { key: 'COMPLETED', label: 'Xong', count: stats.completed },
  ];

  // Clear search and refocus
  const handleClear = () => {
    setSearchQuery('');
    searchRef?.current?.focus();
  };

  return (
    <div style={styles.toolbar}>
      {/* Filter Tabs */}
      <div style={styles.filterTabs}>
        {tabs.map(tab => {
          const isActive = statusFilter === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setStatusFilter(tab.key)}
              style={isActive ? styles.filterTabActive : styles.filterTab}
            >
              <span>{tab.label}</span>
              <span style={isActive ? styles.filterBadgeActive : styles.filterBadge}>
                {tab.count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Search Input */}
      <div style={styles.searchWrap}>
        {Icons.search({ size: 15, color: '#94a3b8' })}
        <input
          ref={searchRef}
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="Tìm bệnh nhân..."
          style={styles.searchInput}
        />
        {searchQuery ? (
          <button onClick={handleClear} style={styles.searchClear}>
            {Icons.x({ size: 14, color: '#94a3b8' })}
          </button>
        ) : (
          <kbd style={styles.searchKbd}>/</kbd>
        )}
      </div>
    </div>
  );
}

export default FilterToolbar;
